import { useState } from 'react';

import styles from './cookie-banner.module.css';

export const CookieBanner = ({
  repub,
  showBanner: initialShowBanner,
}: {
  repub: 'ES' | 'IT';
  showBanner?: boolean;
}) => {
  const [showBanner, setShowBanner] = useState(initialShowBanner);

  const acceptCookies = () => {
    document.cookie = 'hasAcceptedCookies=true; path=/; max-age=31536000';
    setShowBanner(false);
  };

  const bannerCopy = {
    ES: {
      textElement: (
        <p>Por favor, acepta nuestras condiciones generales y la política de cookies y privacidad actualizadas.</p>
      ),
      buttonText: 'Aceptar y cerrar',
    },
    IT: {
      textElement: (
        <p>
          Per favore, accetta i nostri{' '}
          <a
            className={styles.link}
            href="https://www.oddschecker.com/it/termini-e-condizioni"
            rel="noopener noreferrer"
            target="_blank"
          >
            Termini e Condizioni
          </a>{' '}
          aggiornati e la nostra{' '}
          <a
            className={styles.link}
            href="https://www.oddschecker.com/it/informativa-privacy"
            rel="noopener noreferrer"
            target="_blank"
          >
            Informativa Privacy
          </a>
          .
        </p>
      ),
      buttonText: 'Accetta e Chiudi',
    },
  };

  const renderCookieBanner = () => {
    const { buttonText, textElement } = bannerCopy[repub.toUpperCase() as 'ES' | 'IT'];

    return (
      <div className={styles.banner}>
        <div className={styles.bannerText}>
          <div className={styles.iconWrapper}>
            <svg fill="none" height="100%" viewBox="0 0 24 24" width="100%" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 2C6.4863 2 2 6.4858 2 12C2 17.5142 6.4863 22 12 22C17.5137 22 22 17.5142 22 12C22 6.4858 17.5137 2 12 2ZM12 20C7.5889 20 4 16.4111 4 12C4 7.5889 7.5889 4 12 4C16.4111 4 20 7.5889 20 12C20 16.4111 16.4111 20 12 20Z"
                fill="#022E4A"
              />
              <path d="M13.1128 14.877H10.8804V17.0611H13.1128V14.877Z" fill="#022E4A" />
              <path d="M11.3706 13.939H12.6577L13.1968 6.93896H10.8032L11.3706 13.939Z" fill="#022E4A" />
            </svg>
          </div>
          {textElement}
        </div>
        <button className={styles.acceptButton} onClick={acceptCookies}>
          {buttonText}
        </button>
      </div>
    );
  };

  if (!showBanner) {
    return null;
  }

  return renderCookieBanner();
};
